import { render } from "./addMunicipality.vue?vue&type=template&id=2b47b663&scoped=true"
import script from "./addMunicipality.vue?vue&type=script&lang=js"
export * from "./addMunicipality.vue?vue&type=script&lang=js"

import "./addMunicipality.vue?vue&type=style&index=0&id=2b47b663&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b47b663"]])

export default __exports__